import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'FrontMain',
      component: () => import('@/components/FrontMain.vue'),
      redirect:'/products',
      children:[
      {
      	path:'products',
      	name:'Products',
      	component:	() => import('@/components/Products.vue')
      },
       {
        path:'product',
        name:'Product',
        component:  () => import('@/components/ProductDetail.vue')
      },
       {
        path:'news',
        name:'News',
        component: () => import('@/components/News.vue')
      },
       {
        path:'service',
        name:'Service',
        component:  () => import('@/components/Service.vue')
      },
      {
        path:'newscenter',
        name:'NewsCenter',
        component:  () => import('@/components/NewsCenter.vue')
      },
      {
        path:'contact',
        name:'Contact',
        component: () => import('@/components/Contact.vue')
      },
       {
        path:'about',
        name:'About',
        component: () => import('@/components/About.vue')
      }
      ]
    },
    {
        path:'/login',
        name:'Login',
        component: () => import('@/components/Login.vue')
    },
    {
      path:'/backend',
    	name:'BackendMain',
    	component: () => import('@/components/backend/BackendMain'),
    	children:[
       {
          path:'cateList',
          name:'CateList',
          component: () => import('@/components/backend/CateList.vue')
        },
    		{
    			path:'prdList',
    			name:'PrdList',
    			component: () => import('@/components/backend/PrdList.vue')
    		},
        {
          path:'prd',
          name:'Prd',
          component: () => import('@/components/backend/PrdAdd.vue')
        },
        {
          path:'news/add',
          name:'NewsAdd',
          component: () => import('@/components/backend/NewsAdd.vue')
        },
        {
          path:'newsList',
          name:'NewsList',
          component: () => import('@/components/backend/NewsList.vue')
        },
        {
          path:'report',
          name:'Report',
          component: () => import('@/components/backend/Report.vue')
        }
    	]}

      ]
})

// 挂在路由导航守卫
router.beforeEach((to, from, next) => {
  
  // to：将要访问的路径
  // from：从哪个路径跳转而来
  // next：是一个函数，表示放行
  // 1. next() 放行  2. next('/login') 强制跳转
  // 如果访问的是登录页，则直接放行
  if (to.path === '/login') return next()
  // 如果没有被return出去，则表示用户访问的不是登录页
  // 获取token
  const tokenStr = window.sessionStorage.getItem('MC-Token')
  // 如果没有token，则处于未登录状态，强制返回到登陆页面
  if (to.path.indexOf('/backend') >= 0 && !tokenStr) 
    return next('/login')
  // 存在token则直接放行
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js